import { createContext, useContext, useMemo, useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { Vector3 } from "three";
import { Sun, Focus, Waves, Database, Factory } from "lucide-react";
import { PARTS } from "./content";

export const partIcons = { mirrors: Sun, receiver: Focus, pipes: Waves, storage: Database, industry: Factory };

export const HotspotContext = createContext(null);

export function Hotspot({ part, position }) {
  const anchor = useRef();
  const nodes = useContext(HotspotContext);
  const point = useMemo(() => new Vector3(), []);
  useFrame(({ camera, size }) => {
    const node = nodes.current[part];
    if (!node || !anchor.current) return;
    anchor.current.getWorldPosition(point).project(camera);
    node.style.visibility = Math.abs(point.x) > 0.98 || Math.abs(point.y) > 0.95 || point.z > 1 ? "hidden" : "visible";
    node.style.transform = `translate3d(${(point.x + 1) * size.width / 2}px, ${(1 - point.y) * size.height / 2}px, 0) translate(-50%, -50%)`;
  });
  return <group ref={anchor} position={position} />;
}

export function HotspotOverlay({ nodes, selected, onSelect, copy }) {
  return (
    <div className="absolute inset-0 pointer-events-none" data-testid="model-hotspots">
      {PARTS.map(part => {
        const Icon = partIcons[part];
        return (
      <button
        key={part} ref={node => { nodes.current[part] = node; }} style={{ visibility: "hidden" }}
        type="button" title={copy.parts[part].name} aria-label={copy.parts[part].name}
        aria-pressed={selected === part} data-testid={`model-hotspot-${part}`}
        onClick={(event) => { event.stopPropagation(); onSelect(part); }}
        className={`absolute left-0 top-0 pointer-events-auto flex h-7 w-7 sm:h-9 sm:w-9 items-center justify-center rounded-full border transition-[background-color,border-color] focus-visible:outline focus-visible:outline-2 focus-visible:outline-volt ${selected === part ? "border-volt bg-volt text-anthracite" : "border-white/40 bg-anthracite text-white hover:border-volt"}`}
      ><Icon size={15} aria-hidden="true" /></button>
        );
      })}
    </div>
  );
}